import script from "./HospitalList.vue?vue&type=script&lang=ts&setup=true"
export * from "./HospitalList.vue?vue&type=script&lang=ts&setup=true"

import "./HospitalList.vue?vue&type=style&index=0&id=f24f3b08&lang=less&scoped=true"

import exportComponent from "/root/.jenkins/workspace/test-saas-doctor/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f24f3b08"]])

export default __exports__